// Where to send someone after they sign in: the protected page they opened
// while signed out (e.g. a /credits?offer=… link). Kept in sessionStorage so it
// survives the OAuth round trip and the OTP step, which both land on "/".
const KEY = "post-auth-redirect";

// Same-origin paths only, so the param can't be used as an open redirect.
export function isAppPath(path: unknown): path is string {
  return (
    typeof path === "string" && path.startsWith("/") && !path.startsWith("//")
  );
}

export function savePostAuthRedirect(path: string) {
  sessionStorage.setItem(KEY, path);
}

export function takePostAuthRedirect(): string | null {
  const path = sessionStorage.getItem(KEY);
  sessionStorage.removeItem(KEY);
  return isAppPath(path) ? path : null;
}
